import {
	ADMINGETKYCACTIONTYPE_SUCCESS,
	ADMINGETKYCACTIONTYPE_FAILED,
	RESET_ADMINGETKYCACTIONTYPE,
	LOADING_ADMINGETKYCACTIONTYPE,
	NETWORK_ERROR_ADMINGETKYCACTIONTYPE
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETKYCACTIONTYPE:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINGETKYCACTIONTYPE_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINGETKYCACTIONTYPE_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINGETKYCACTIONTYPE:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINGETKYCACTIONTYPE:
			return (state = initialState);
		default:
			return state;
	}
};
